// @ts-nocheck
import { populate } from 'populate';
import type { Container, Graphics, NineSlicePlane, Text, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '90160241-3036-40ee-add5-d834bb1c0eac',
      type: 'Graphics',
      name: 'overlay',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      commands: [
        {
          id: 'a225fb2f-b80e-4639-be1f-ca8e9e45c6c4',
          type: 'beginFill',
          color: 0,
          alpha: 1
        },
        {
          id: 'e43a55e9-732a-45b7-8006-f7541e38bac9',
          type: 'drawRect',
          x: -3000,
          y: -3000,
          width: 6000,
          height: 6000
        },
        {
          id: '493544da-17bf-4a4c-afda-634eb41ea605',
          type: 'beginFill',
          color: 0,
          alpha: 1
        }
      ]
    },
    {
      id: 'b5881690-6c88-43af-af85-215c14ca9d13',
      type: 'Container',
      name: 'progressBarWrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -370,
        y: -62,
        width: 740,
        height: 120
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '6f385979-be17-434e-bc25-19544c673cd4',
      type: 'NineSlicePlane',
      name: 'progressBarBackground',
      className: '',
      x: -375,
      y: -60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 750,
      height: 95,
      leftWidth: 39,
      topHeight: 32,
      rightWidth: 39,
      bottomHeight: 47,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Progress_Bar_Background_9Slice_39x32x39x47',
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '6338e8b4-d753-43ab-b57c-f1296e6d0e00',
      type: 'NineSlicePlane',
      name: 'progressBarEmpty',
      className: '',
      x: -305,
      y: -37,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 610,
      height: 35,
      leftWidth: 19,
      topHeight: 0,
      rightWidth: 19,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Progress_Bar_Empty_3Slice_19x19',
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: 'bc1dc742-18f7-45f6-b508-7fc2a592655e',
      type: 'NineSlicePlane',
      name: 'progressBarFill',
      className: '',
      x: -305,
      y: -37,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 610,
      height: 35,
      leftWidth: 19,
      topHeight: 0,
      rightWidth: 19,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Progress_Bar_Full_3Slice_19x19',
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '5efffd13-3ddf-44a1-9176-f37427e5a359',
      type: 'NineSlicePlane',
      name: 'timerBackground',
      className: '',
      x: -78,
      y: 12,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 156,
      height: 64,
      leftWidth: 32,
      topHeight: 0,
      rightWidth: 32,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Progress_Bar_Timer_9Slice_32x0x32x0',
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '6aa94426-bea7-424d-863a-d9eac7ccd4e0',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 13,
      y: 33,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Xd XXh',
      localize: false,
      maxWidth: 80,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '4b60a1e0-a341-4aab-96ce-dea0ec82bffc',
      type: 'Text',
      name: 'progressText',
      className: '',
      x: 0,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1000/2000',
      localize: false,
      maxWidth: 330,
      maxHeight: 45,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0A46E1',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '7754e628-30c1-4072-aec7-aa51762b5916',
      type: 'Sprite',
      name: 'clock',
      className: '',
      x: -47,
      y: 33,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '7ffa00a0-a4af-4af0-8880-9bed1602b1ce',
      type: 'Container',
      name: 'tokenFxSlot',
      className: '',
      x: -319,
      y: -19,
      scale: {
        x: 0.4,
        y: 0.4
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: 'b98120ac-d35e-4ecd-aabb-4877f8d85a3f',
      type: 'Container',
      name: 'tokenSlot',
      className: '',
      x: -310,
      y: -19,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '97ff588b-450c-4214-9d31-57c1da4a0af8',
      type: 'Container',
      name: 'rewardSlot',
      className: '',
      x: 310,
      y: -19,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '7bdbc629-bbe2-42cd-8dfa-9ea907dffdb6',
      type: 'Container',
      name: 'rewardAnimationSlot',
      className: '',
      x: 0,
      y: -460,
      scale: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: '59492726-2a9f-497e-b281-11119d489f9b',
      type: 'Sprite',
      name: 'tokenFxFlash',
      className: '',
      x: -319,
      y: -19,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'b5881690-6c88-43af-af85-215c14ca9d13'
    },
    {
      id: 'ecff133e-662d-411c-9d9e-626ff311e1b6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.35,
        y: 0.35
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Icon_Leaf',
      parent: '7bdbc629-bbe2-42cd-8dfa-9ea907dffdb6',
      data: {
        DEBUG: true
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: '74a4ce4d-5a6b-48ec-b688-1e6c3c2b0246',
      name: 'Collect_Animation',
      playingSpeed: 1,
      totalDuration: 1300,
      blocks: [
        {
          id: '0065e27c-5277-4040-b584-326eee40d4f3',
          type: 'Setter',
          name: 'rewardAnimationSlotReset',
          track: 4,
          target: {
            x: 0,
            y: -460,
            alpha: 1,
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'rewardAnimationSlot',
          disabled: false
        },
        {
          id: 'd5483824-dccd-4fa7-8d28-081afe2ef93b',
          type: 'Setter',
          name: 'SET_overlay',
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'overlay',
          disabled: false
        },
        {
          id: '14768fff-b09f-47b4-a9aa-b335c967846d',
          type: 'Tween',
          name: 'overlay',
          duration: 300,
          track: 2,
          target: {
            alpha: 0.8
          },
          startAt: 0,
          sourceName: 'overlay',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '8b20b565-ba0d-49a4-bbc8-0112889801fd',
          type: 'Tween',
          name: 'iconScaleIn',
          duration: 300,
          track: 3,
          target: {
            scale: {
              y: 3,
              x: 3
            }
          },
          startAt: 102,
          sourceName: 'rewardAnimationSlot',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '6c7584d3-ffe9-46c5-94da-0169261f33aa',
          type: 'Tween',
          name: 'iconX',
          duration: 700,
          track: 7,
          target: {
            x: -310
          },
          startAt: 402,
          sourceName: 'rewardAnimationSlot',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: 'd01987e1-9b17-4e2f-ba48-f35f930bc340',
          type: 'Tween',
          name: 'iconY',
          duration: 700,
          track: 5,
          target: {
            y: -19
          },
          startAt: 402,
          sourceName: 'rewardAnimationSlot',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'cb60ea68-da76-4ab3-a8c0-b497b0172566',
          type: 'Tween',
          name: 'iconScale',
          duration: 700,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 402,
          sourceName: 'rewardAnimationSlot',
          easing: 'CircularOut',
          disabled: false
        },
        {
          id: '53215459-0c2f-424b-a816-2500156e759c',
          type: 'Tween',
          name: 'overlay_copy',
          duration: 300,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 1000,
          sourceName: 'overlay',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '7b4e3360-8c82-4357-8fa3-342c2b48cb8d',
          type: 'Setter',
          name: 'FXPART_Collect_Event_Particle',
          track: 9,
          target: {},
          startAt: 1100,
          sourceName: 'tokenFxSlot',
          disabled: false
        },
        {
          id: '896246d5-dfa4-4e81-8563-e6f1abc80a91',
          type: 'Setter',
          name: 'hideRewardAnimationSlot',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 1102,
          sourceName: 'rewardAnimationSlot',
          disabled: false
        },
        {
          id: '832425a6-3a7f-4aff-8036-d38f6939f1fc',
          type: 'Setter',
          name: 'fxFlashSetter',
          track: 6,
          target: {
            alpha: 0.5
          },
          startAt: 1102,
          sourceName: 'tokenFxFlash',
          disabled: false
        },
        {
          id: 'fd77a795-5b90-4679-925b-6a5aac764d80',
          type: 'Setter',
          name: 'ANIMEVENT_startProgressBarAnimation',
          track: 8,
          target: {},
          startAt: 1103,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '578b945b-8f72-4bb6-a718-2f1b3e7f6e37',
          type: 'Tween',
          name: 'tokenFlashFadeOut',
          duration: 300,
          track: 6,
          target: {
            alpha: 0,
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 1107,
          sourceName: 'tokenFxFlash',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    },
    {
      id: '712a04d5-7857-4685-ae0d-b06f1cd7458e',
      name: 'Collect_Animation_Finished',
      playingSpeed: 1,
      totalDuration: 10,
      blocks: [
        {
          id: '6666c46b-6b20-4805-9bb5-5dbc6bb73b2f',
          type: 'Setter',
          name: 'SET_overlay_1',
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'overlay',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class CollectEventProgressBarMainMenuLayout {
  static raw = raw;
  root!: Container;
  overlay!: Graphics;
  progressBarWrapper!: Container;
  progressBarBackground!: NineSlicePlane;
  progressBarEmpty!: NineSlicePlane;
  progressBarFill!: NineSlicePlane;
  timerBackground!: NineSlicePlane;
  timerText!: Text;
  progressText!: Text;
  clock!: Sprite;
  tokenFxSlot!: Container;
  tokenSlot!: Container;
  rewardSlot!: Container;
  rewardAnimationSlot!: Container;
  tokenFxFlash!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Collect_Animation {
  Layout: {
    rewardAnimationSlot: object;
    overlay: object;
    tokenFxSlot: object;
    tokenFxFlash: object;
    root: object;
  };

  BlockTypeByName: {
    rewardAnimationSlotReset: object;
    SET_overlay: object;
    overlay: object;
    iconScaleIn: object;
    iconX: object;
    iconY: object;
    iconScale: object;
    overlay_copy: object;
    FXPART_Collect_Event_Particle: object;
    hideRewardAnimationSlot: object;
    fxFlashSetter: object;
    ANIMEVENT_startProgressBarAnimation: object;
    tokenFlashFadeOut: object;
  };

  flowData = raw.animations[0];
}

export abstract class Collect_Animation_Finished {
  Layout: {
    overlay: object;
  };

  BlockTypeByName: {
    SET_overlay_1: object;
  };

  flowData = raw.animations[1];
}
